import classNames from 'classnames';
import { useConsentContext } from 'contexts/ConsentContext';
import useBreakPoint from 'hooks/useBreakPoint';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link as RouterLink, useRouteMatch } from 'react-router-dom';
import { Breakpoint } from 'types/breakpoint';
import isExternalLink from 'utils/isExternalLink';

import { Route, useRoutes } from './shared';
import styles from './SidebarNavigation.module.scss';

const SidebarItem = ({ to, text, icon }: Route) => {
    const match = useRouteMatch({
        path: to,
        strict: true,
        sensitive: true,
    });
    const isMediumDesktop = useBreakPoint(Breakpoint.mediumDesktop);
    const isSmallDesktop = useBreakPoint(Breakpoint.smallDesktop);
    const isExtraSmallDesktop = useBreakPoint(Breakpoint.extraSmallDesktop);
    const isActive = match?.path === "/" ? match.isExact : match;

    function newTab(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        if (isExternalLink(to)) {
            window.open(to);
            e.preventDefault();
        }
    }

    return (
        <li
            className={classNames(styles["item"], {
                [styles["item--active"]]: isActive,
                [styles["item--medium"]]: isMediumDesktop,
                [styles["item--small"]]: isSmallDesktop,
                [styles["item--extraSmall"]]: isExtraSmallDesktop,
            })}
        >
            <RouterLink onClick={newTab} to={to} className={styles["item__link"]}>
                {React.cloneElement(icon, {
                    className: classNames(styles["item__icon"], {
                        [styles["item__icon--medium"]]: isMediumDesktop,
                        [styles["item__icon--small"]]: isSmallDesktop,
                        [styles["item__icon--extraSmall"]]: isExtraSmallDesktop,
                    }),
                })}
                <span
                    className={classNames(styles["item__text"], {
                        [styles["item__text--active"]]: isActive,
                        [styles["item__text--medium"]]: isMediumDesktop,
                        [styles["item__text--small"]]: isSmallDesktop,
                        [styles["item__text--extraSmall"]]: isExtraSmallDesktop,
                    })}
                >
                    {text}
                </span>
            </RouterLink>
        </li>
    );
};

const SidebarNavigation = () => {
    const { reOpen } = useConsentContext();

    const routes = useRoutes();
    const intl = useIntl();
    return (
        <nav className={styles["sidebar"]}>
            <ul className={styles["sidebar__list"]}>
                {routes.map((route) => {
                    return (
                        <SidebarItem
                            to={route.to}
                            text={route.text}
                            icon={route.icon}
                            key={route.to}
                        />
                    );
                })}
            </ul>
            <button onClick={reOpen} className={styles["sidebar__privacy_notice"]}>
                {intl.formatMessage({ id: "view_name.privacy_notice" })}
            </button>
        </nav>
    );
};

export default SidebarNavigation;
